<template>
    <div class="animated fadeIn">
        <div class="card">
            <div class="card-header main-card-header">
                <span>Wallet QR</span>
                <div class="card-header-actions"></div>
            </div>
            <div class="card-body main-card-body">
                <div class="mt-4">
                    <b-row class="mb-3">
                        <b-col xl="3" lg="4" md="6" class="mb-3">
                            <div
                                class="d-flex justify-content-center"
                                style="flex-direction: column; align-items: center;"
                            >
                                <div @click="fn_showModalQrCertificate(mData.dataDefault.data.qr,mData.dataDefault.data.qr)">
                                <QrCode
                                    :text="
                                    mData.dataDefault.data && mData.dataDefault.data.qr
                                        ? mData.dataDefault.data.qr
                                        : ''
                                    "
                                />
                                </div>
                                <h4 class="mt-3 id-name">
                                    {{
                                    mData.dataDefault.data && mData.dataDefault.data.qr
                                        ? mData.dataDefault.data.qr
                                        : ""
                                    }}
                                </h4>
                            </div>
                        </b-col>

                        <b-col xl="3" lg="4" md="6" v-for="item in mData.dataDefault.arrQrTestCertificate" :key="item.id" class="mb-3">
                            <div
                                class="d-flex justify-content-center"
                                style="flex-direction: column; align-items: center;"
                            >
                                <div @click="fn_showModalQrCertificate(item.qr_code,item.ngay_xet_nghiem)">
                                    <QrCode
                                        :text="item.qr_code ? item.qr_code : ''"
                                    />
                                </div>
                                <h4 class="mt-3 id-name">
                                    Test date {{item.ngay_xet_nghiem | dateFormat}}
                                </h4>
                            </div>
                        </b-col>

                        <b-col  xl="3" lg="4" md="6" class="mb-3" v-if="mData.checkShowQrVaccination">
                            <div
                                class="d-flex justify-content-center"
                                style="flex-direction: column; align-items: center;"
                            >
                                <div @click="fn_showModalQrCertificate(mData.dataDefault.data.khai_bao.tiem_chung.qr,'Vaccination certificate')">
                                    <QrCode
                                        :text="
                                        mData.dataDefault.data && 
                                        mData.dataDefault.data.khai_bao && 
                                        mData.dataDefault.data.khai_bao.tiem_chung && 
                                        mData.dataDefault.data.khai_bao.tiem_chung.qr ? mData.dataDefault.data.khai_bao.tiem_chung.qr : ''
                                        "
                                    />
                                </div>
                                <h4 class="mt-3 id-name">
                                    {{text}}
                                </h4>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <el-dialog title="Detail" width="33%" :visible.sync="showModalQrCertificate">
            <div class="qr-certificate">
                <QrCode
                    :size="1000"
                    error-level="L"
                    :text="this.qrTestCertificate"
                />
                <h4 class="mt-3 mb-3 id-name">
                    {{ this.qrText }}
                </h4>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import QuocGiaApi from '../../../moduleApi/QuocGiaApi';
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from '../../../service/ExtensionService';
import QrCode from "vue-qrcode-component";
import * as moment from 'moment';

export default {
    components: { QrCode },
    filters: {
        dateFormat: function (value) {
            let format = "DD/MM/YYYY";
            if (!value) return ''
            return moment(value).format(format);
        }
    },
    data() {
        return {
            aLang: LanguageService.lang,
            aElement: MethodService.element,
            text: '',
            imgUrl: ExtensionService.urlImg,
            mData: {
                checkShowQr: false,
                checkShowQrVaccination: false,
                checkShowQrTestCretificate: false,
                data: [],
                dataDefault: {
                    listQuocGia: [],
                    listForeigner: [],
                    arrQrTestCertificate: [],
                    data: null,
                    anhVaccination:"",
                },
            },
            qrTestCertificate: "",
            qrText: "",
            showModalQrCertificate: false,
        };
    },
    methods: {
        fn_showModalQrCertificate(qr,text){
            this.showModalQrCertificate = true;
            this.qrTestCertificate = qr;
            if(text == "Vaccination certificate"){
                this.qrText = text;
            }else if(text.substring(0, 3) === "TP-"){
                this.qrText = text;
            }else{
                this.qrText = this.fn_formatterDate(text);
            }
            console.log("this.qrText",this.qrText);
        },
        fn_formatterDate(value) {
            let format = "DD/MM/YYYY";
            if (!value) return ''
            return moment(value).format(format);
        },
        async fn_initData(){
            try {
                let quocGiaRes = await QuocGiaApi.list();
                this.mData.dataDefault.listQuocGia = quocGiaRes.result;
                let vietNam = this.mData.dataDefault.listQuocGia.find(maQG => maQG.ma.alpha_2 == "VN");
                let res = await ForeignerQrApi.list({
                    filters: "trang_thai:nin:da_xuat_canh,khong_hop_le",
                });
                if (res.result && res.result.length > 0) {
                    this.mData.dataDefault.data = res.result[0];
                    if(
                        [
                        "cho_cap_visa",
                        ].includes(this.mData.dataDefault.data.trang_thai) &&
                        this.mData.dataDefault.data.khai_bao.tiem_chung.anh_id != null
                    ){
                        this.mData.checkShowQr = true;
                        this.mData.checkShowQrTestCretificate = true;
                        this.mData.checkShowQrVaccination = false;
                    }
                    else if (
                        this.mData.dataDefault.data.trang_thai &&
                        [
                        "cho_cap_visa",
                        "cho_nhap_visa",
                        "cho_nhap_canh",
                        "da_nhap_canh",
                        "cho_duyet_vaccine"
                        ].includes(this.mData.dataDefault.data.trang_thai)
                    ) {
                        this.mData.checkShowQr = true;
                        this.mData.checkShowQrTestCretificate = true;
                        this.mData.checkShowQrVaccination = true;
                    }
                    if(res.result[0].xet_nghiem){
                        let arrQrTestCertificateAproved = res.result[0].xet_nghiem.filter(e => {
                            return e.duoc_duyet === true || e.quoc_gia_id == vietNam.id;
                        })
                        if(arrQrTestCertificateAproved.length > 0){
                            this.mData.dataDefault.arrQrTestCertificate = arrQrTestCertificateAproved.reverse();
                        }
                    
                    }else{
                        this.mData.dataDefault.arrQrTestCertificate = [];
                    }
                } 
                this.text = "Vaccination certificate";
                console.log('mData.dataDefault.data',this.mData.dataDefault.data);
            } catch (error) {
                console.log(error);
            }
        },
        //xử lý dữ liệu đầu ra
        changeData(data) {
            return data;
        },
    },
    async mounted() {
        this.fn_initData();
    },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap');
p{
    margin-bottom: 0;
}
.main-card-header{
  position: fixed;
  top: 60px;
  width: 100%;
  height: 43px;
  z-index : 3;
  background-color: #cdf3f8;
  border-color: #cdf3f8;
  display: flex;
  align-items: center;
}
.main-card-header span{
  font-family: MYRIADPRO-REGULAR;
  color: #0c66ad;
  font-weight: 600;
}
.main-card-body{
  position: relative;
  top: 43px;
  min-height: calc(100vh - 128px);
}
::v-deep .el-collapse-item__wrap{
    position: relative;
}
::v-deep .el-collapse-item__header {
    height: 40px;
    color: #0c66ad;
    font-family: MYRIADPRO-REGULAR;
    font-weight: 600;
    font-size: 15px;
}

::v-deep .el-collapse-item__arrow{
    font-weight: 1000;
}

.title-list{
    font-size: 16px;
    font-weight: 500;
}

.infomation{
    font-size: 14px;
    font-weight: 400;
}
.qr-certificate{
  display: flex;
  justify-content: center;
  margin: 20px 0;
  flex-direction: column; 
  align-items: center;
}
::v-deep .qr-certificate div img{
  width: 500px;
}
@media (max-width: 1650px) {
    ::v-deep .el-dialog{
        width: 40% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 450px;
    }
    .qr-certificate h4{
        font-size: 21px;
    }
}

@media (max-width: 1300px) {
    ::v-deep .el-dialog{
        width: 42% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 370px;
    }
    .qr-certificate h4{
        font-size: 20px;
    }
}

@media (max-width: 990px) {
    ::v-deep .el-dialog{
        width: 50% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 290px;
    }
    .qr-certificate h4{
        font-size: 19px;
    }
}
@media (max-width: 650px) {
    ::v-deep .el-dialog{
        width: 57% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 270px;
    }
    .qr-certificate h4{
        font-size: 18px;
    }
}

@media (max-width: 500px) {
    ::v-deep .el-dialog{
        width: 73% !important;
    }
    ::v-deep .qr-certificate div img{
        width: 270px;
    }
    .qr-certificate h4{
        font-size: 17px;
    }
}

@media (max-width: 400px) {
    ::v-deep .qr-certificate div img{
        width: 220px;
    }
    .qr-certificate h4{
        font-size: 16px;
    }
}

@media (max-width: 310px) {
    ::v-deep .qr-certificate div img{
        width: 190px;
    }
    .qr-certificate h4{
        font-size: 14px;
    }
}
</style>